import { render, staticRenderFns } from "./prompt-dialog.vue?vue&type=template&id=70719f06&"
import script from "./prompt-dialog.component.ts?vue&type=script&lang=ts&"
export * from "./prompt-dialog.component.ts?vue&type=script&lang=ts&"
import style0 from "./prompt-dialog.vue?vue&type=style&index=0&id=70719f06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports